var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/* eslint-disable camelcase, @typescript-eslint/naming-convention */
import api from '@utils/axios';
/**
 * `useDirectUpload`'s transport for invoice attachments.
 *
 * Uses the raw `@utils/axios` client, NOT `@utils/api-client` -- `api-client`'s case-converter
 * would camelCase this endpoint's response (`signed_id` -> `signedId`) and the hook expects the
 * Frozen contract's wire shapes verbatim, snake_case included. Mirrors the Building, Inspection
 * and Work Order transports for the same reason.
 */
export function createDirectUploadTransport(invoiceId) {
    const base = `/api/internal/invoices/${invoiceId}/attachment_uploads`;
    return {
        presign: (request, signal) => __awaiter(this, void 0, void 0, function* () {
            const response = yield api.post(base, request, { signal });
            return response.data;
        }),
        // The wire body is rooted at `invoice_attachments` (the controller's `response_root`); the
        // hook consumes a normalised `attachments`. Unwrapping here keeps the hook generic.
        finalize: (request, signal) => __awaiter(this, void 0, void 0, function* () {
            const response = yield api.post(`${base}/finalize`, request, {
                signal
            });
            return { attachments: response.data.invoice_attachments };
        })
    };
}
